import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
} from "react-bootstrap";
import { signUp, resetSignUp } from "../../actions/auth-action";
import { Link, Redirect } from "react-router-dom";
import "./SignUp.scss";
import useInput from "../hooks/useInput";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { t } from "i18next";
import { Trans, useTranslation } from "react-i18next";

const SignUp = (props) => {
  const { signUp, resetSignUp } = props;
  const { search } = useLocation();
  const query = queryString.parse(search);
  const {t} = useTranslation()

  const signUpError = useSelector((state) => state.auth.signUpError);
  const signUpRedirect = useSelector((state) => state.auth.signUpRedirect);
  const signUpStart = useSelector((state) => state.auth.signUpStart);
  const signUpSuccess = useSelector((state) => state.auth.signUpSuccess);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [referralCode, bindReferralCode] = useInput(query.ref || "");
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    resetSignUp();
    return () => {
      resetSignUp();
    };
  }, []);

  const clickSignUp = (e) => {
    e.preventDefault();
    signUp({
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      password_confirmation: confirmPass,
      referral_code: referralCode,
      from: "web",
    });
  };
  if (signUpRedirect) {
    return <Redirect to="/verify-otp" />;
  }
  return (
    <>
      <Header />
      <div className="login-panel register-panel">
        <Row>
          <Col className="left-panel">
            <div>
              <img src="/images/login.png" className="feature-image" alt="banner" width={500} height={350}/>
            </div>
          </Col>
          <Col className="right-panel">
            <div className="signup-panel">
              <h6 className="header-text">{t("create-new-acc")}</h6>
              <Form className="mt-5">
                <Form.Group className="ch-form">
                  <Form.Control
                    as="input"
                    placeholder={t("first-name")}
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  ></Form.Control>
                </Form.Group>
                <Form.Group className="ch-form">
                  <Form.Control
                    as="input"
                    placeholder={t("last-name")}
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  ></Form.Control>
                </Form.Group>
                <Form.Group className="ch-form">
                  <Form.Control
                    as="input"
                    placeholder={t("email")}
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  ></Form.Control>
                </Form.Group>
                <Form.Group className="ch-form">
                  <Form.Control
                    as="input"
                    placeholder={t("Password")}
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  ></Form.Control>
                </Form.Group>
                <Form.Group className="ch-form">
                  <Form.Control
                    as="input"
                    placeholder={t("re-pass")}
                    type="password"
                    value={confirmPass}
                    onChange={(e) => setConfirmPass(e.target.value)}
                  ></Form.Control>
                </Form.Group>
                <Form.Group className="ch-form">
                  <Form.Control
                    as="input"
                    placeholder={t("ref-code")}
                    {...bindReferralCode}
                    disabled={query.ref != null}
                  />
                </Form.Group>
                
                <input type="checkbox"
                 id="terms-check"
                  className="terms"
                  value={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
                <label htmlFor="terms-check" className="ml-2"><Trans i18nKey={"i-agree"}>
                    <a
                      href="https://www.cfdhero.com/terms.html"
                      target="_blank"
                    >
                    </a>
                  </Trans></label>
                <br></br>
                <Button
                  type="submit"
                  onClick={clickSignUp}
                  variant={checked ? "success" : "secondary"}
                  className="ch-button"
                  disabled={!checked}
                >
                  {signUpStart ? "SUBMITTING..." : "SIGN UP"}
                </Button>

                <Alert
                  show={signUpError != null || signUpSuccess}
                  variant={signUpSuccess ? "success" : "danger"}
                  className="mt-2"
                >
                  {signUpError || t("acc-created-msg")}
                </Alert>
                <div className="mt-3 text-center">
                  <span className="mr-3">{t("have-acc")}</span>
                  <Link to="/login">{t("login")}</Link>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
        <Footer />
      </div>
    </>
  );
};

export default connect(null, { signUp, resetSignUp })(SignUp);
